import React, { useEffect, useRef } from "react";
import QrScanner from "qr-scanner";
import { Modal } from "antd";
import style from "css/mobile/qr.module.css";
import { ReactComponent as CloseIcon } from "asset/common/close_popup.svg";
import { useNavigate } from "react-router-dom";
import { ScanOutlined } from "@ant-design/icons";

const QRScannerComponent = (props) => {
  const videoRef = useRef(null);
  //navigate
  const navigate = useNavigate();
  const handleCameraScan = (result) => {
    // 여기에서 스캔 결과를 처리합니다
    const resourceId = new URL(result.data).searchParams.get("id");
    alert(result.data + " / " + resourceId);
    navigate(process.env.REACT_APP_CLIENT_URL + "app/checkin?id=" + resourceId);
  };
  const handleScan = (result) => {
    // 여기에서 스캔 결과를 처리합니다
    const id = new URL(result.data).searchParams.get("id");
    const type = new URL(result.data).searchParams.get("type");
    props.scan(id, type);
    props.close();
  };

  useEffect(() => {
    if (videoRef.current) {
      const qrScanner = new QrScanner(videoRef.current, handleScan, {
        preferredCamera: "environment",
        maxScansPerSecond: 1,
        highlightScanRegion: true,
      });
      qrScanner.start();

      return () => qrScanner.destroy();
    }
  }, []);

  return (
    <div className={style.qr_scanner_wrap}>
      <div className={style.qr_scanner_header}>
        <span>QR 코드 스캔</span>
        <div
          className={style.qr_scanner_close_btn}
          onClick={() => props.close()}
        >
          <CloseIcon />
        </div>
      </div>
      <video className={style.qr_scanner} ref={videoRef} />
      <div className={style.qr_scanner_footer}>
        <span>예약하신 자리의 QR 코드를 스캔해주세요.</span>
        <div className={style.qr_scanner_icon_wrap}>
          <ScanOutlined />
          <span>코드 스캔</span>
        </div>
      </div>
    </div>
  );
};

export default QRScannerComponent;
